export default function CompanyInfo() {
  return (
    <section className="py-24 px-8 bg-white">
      <div className="max-w-[1000px] mx-auto">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-16 text-center">
          会社情報
        </h2>
        
        <div className="space-y-1">
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 py-6 border-b border-gray-200">
            <div className="text-base font-bold text-gray-900">
              事業者名
            </div>
            <div className="text-base text-gray-700">
              スーパースプーン
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 py-6 border-b border-gray-200">
            <div className="text-base font-bold text-gray-900">
              代表者
            </div>
            <div className="text-base text-gray-700">
              油谷 和好（あぶらたに かずよし）
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 py-6 border-b border-gray-200">
            <div className="text-base font-bold text-gray-900">
              所在地
            </div>
            <div className="text-base text-gray-700">
              〒599-8242<br />
              大阪府堺市中区平井
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 py-6 border-b border-gray-200">
            <div className="text-base font-bold text-gray-900">
              電話番号
            </div>
            <div className="text-base text-gray-700">
              <a href="tel:0722003299" className="hover:text-primary transition-colors cursor-pointer">
                072-200-3299
              </a>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 py-6 border-b border-gray-200">
            <div className="text-base font-bold text-gray-900">
              メールアドレス
            </div>
            <div className="text-base text-gray-700">
              <a href="mailto:abu@superspoon.net" className="hover:text-primary transition-colors cursor-pointer">
                abu@superspoon.net
              </a>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-6 py-6 border-b border-gray-200">
            <div className="text-base font-bold text-gray-900">
              事業内容
            </div>
            <div className="text-base text-gray-700">
              <ul className="space-y-2">
                <li>• EC事業の業務設計・自動化コンサルティング</li>
                <li>• Amazon・楽天・Yahoo!ショッピング等の運営支援</li>
                <li>• AI分析を活用したデータドリブン経営支援</li>
                <li>• デジタルマーケティング戦略立案・実行支援</li>
                <li>• Web/EC/SNS/広告の統合マーケティング</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
